<script setup>
import OpenNoTaskComponent from "@/Components/Claims/OpenNoTaskComponent.vue";
import TasksPendingDashComponent from "@/Components/TasksPending/TasksPendingDashComponent.vue";
import TaskspendingReviewerDash from "@/Components/TasksPending/TaskspendingReviewerDash.vue";
import MessagesAdjusterComponent from "@/Components/Messaging/MessagesAdjusterComponent.vue";
import TasksPendingAcctMgrAttnNeeded from "@/Components/TasksPending/TasksPendingAcctMgrAttnNeeded.vue";

import {Permissions} from "@/Utils/Permissions";
import ClientCollectionsTable from "@/Components/Reports/ClientCollectionsTable.vue";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list'])">
    <v-col cols="12">
      <TasksPendingAcctMgrAttnNeeded/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['messages.list'])">
    <v-col cols="12">
      <MessagesAdjusterComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['claims.open-no-task'])">
    <v-col cols="12">
      <OpenNoTaskComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list'])">
    <v-col cols="12">
      <TasksPendingDashComponent contextSchemaA="claims"/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['tasks-pending.list-reviewer'])">
    <v-col cols="12">
      <TaskspendingReviewerDash contextSchemaA="claims"/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['reports.client-collection'])">
    <v-col cols="12">
      <ClientCollectionsTable contextSchemaA="claims"/>
    </v-col>
  </v-row>
</template>